(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aries-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aries-home-editorial')){
  customElements.define('aries-home-editorial',class extends HTMLElement{
    connectedCallback(){
      this.cleanup?.abort();this.cleanup=new AbortController();const signal=this.cleanup.signal;
      const slides=[...this.querySelectorAll('[data-ad-slide]')],dots=[...this.querySelectorAll('[data-ad-dot]')],controls=this.querySelector('[data-ad-controls]'),play=this.querySelector('[data-ad-playback]'),icon=this.querySelector('[data-ad-playback-icon]'),status=this.querySelector('[data-ad-status]');
      if(slides.length<2||!controls||!play)return;
      const motion=matchMedia('(prefers-reduced-motion: reduce)'),loads=new WeakMap();let index=0,sequence=0,paused=this.dataset.autoplay!=='true'||motion.matches,hover=false,focus=this.contains(document.activeElement),touchStart=null,inView=true;
      const clear=()=>{clearTimeout(this.timer);this.timer=null;};
      const schedule=()=>{clear();if(!paused&&!hover&&!focus&&!document.hidden&&inView)this.timer=setTimeout(()=>show(index+1,false),7000);};
      const playback=()=>{play.setAttribute('aria-pressed',String(paused));play.setAttribute('aria-label',paused?this.dataset.playLabel:this.dataset.pauseLabel);icon.textContent=paused?'▶':'Ⅱ';};
      const ready=slide=>{const img=slide.querySelector('img');if(!img)return Promise.resolve(false);if(loads.has(img))return loads.get(img);img.loading='eager';const loading=(async()=>{try{await img.decode();return img.naturalWidth>0;}catch{return img.complete&&img.naturalWidth>0;}})();loads.set(img,loading);return loading;};
      const warmNext=()=>{clearTimeout(this.warmTimer);this.warmTimer=setTimeout(()=>{if(this.isConnected&&!signal.aborted)ready(slides[(index+1)%slides.length]);},200);};
      const show=async(next,manual)=>{clear();const requested=(next+slides.length)%slides.length,request=++sequence;if(requested!==index){const loaded=await ready(slides[requested]);if(signal.aborted||request!==sequence)return;if(!loaded){if(manual&&status)status.textContent=this.dataset.imageError;schedule();return;}}index=requested;slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.inert=i!==index;});dots.forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});if(manual&&status)status.textContent=slides[index].getAttribute('aria-label');warmNext();schedule();};
      this.querySelector('[data-ad-prev]').addEventListener('click',()=>show(index-1,true),{signal});this.querySelector('[data-ad-next]').addEventListener('click',()=>show(index+1,true),{signal});dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i,true),{signal}));
      play.addEventListener('click',()=>{paused=!paused;playback();schedule();},{signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hover=true;schedule();}},{signal});this.addEventListener('pointerleave',()=>{hover=false;schedule();},{signal});this.addEventListener('focusin',()=>{focus=true;schedule();},{signal});this.addEventListener('focusout',event=>{focus=this.contains(event.relatedTarget);schedule();},{signal});document.addEventListener('visibilitychange',schedule,{signal});motion.addEventListener('change',()=>{if(motion.matches)paused=true;playback();schedule();},{signal});
      this.addEventListener('touchstart',event=>{if(event.touches.length===1&&!event.target.closest('a,button'))touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};else touchStart=null;},{passive:true,signal});this.addEventListener('touchend',event=>{if(!touchStart||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;touchStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.3)show(index+(dx<0?1:-1),true);},{passive:true,signal});
      if('IntersectionObserver'in window){this.visibilityObserver=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.12});this.visibilityObserver.observe(this);}
      controls.hidden=false;playback();ready(slides[0]).finally(()=>{if(!signal.aborted){warmNext();schedule();}});
    }
    disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.warmTimer);this.visibilityObserver?.disconnect();this.cleanup?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
